/* eslint-disable import/no-cycle */

import { DealStatus, SweepOptions } from 'components/common/types/Deal.types';
import { Color } from 'lib/Chip';

export const DEAL_STATUS_BADGE = [
  {
    code: '',
    name: 'New',
    initials: 'N',
    color: Color.PRIMARY,
  },
  {
    code: DealStatus.PENDING_APPROVAL,
    name: 'Pending approval',
    initials: 'PA',
    color: Color.YELLOW,
  },
  {
    code: DealStatus.APPROVED,
    name: 'Approved',
    initials: 'A',
    color: Color.GREEN,
  },
  {
    code: DealStatus.REJECTED,
    name: 'Rejected',
    initials: 'R',
    color: Color.PINK_RED,
  },
  {
    code: DealStatus.LIVE,
    name: 'Live',
    initials: 'L',
    color: Color.LIME,
  },
  {
    code: DealStatus.ENDED,
    name: 'Ended',
    initials: 'E',
    color: Color.GREY,
  },
  {
    code: DealStatus.CANCELLED,
    name: 'Cancelled',
    initials: 'C',
    color: Color.PINK_RED,
  },
  {
    code: DealStatus.TERMINATED,
    name: 'Terminated',
    initials: 'T',
    color: Color.PINK_RED,
  },
  {
    code: DealStatus.FAILED,
    name: 'Failed',
    initials: 'F',
    color: Color.PINK_RED,
  },
  {
    code: DealStatus.PENDING_RESERVATION,
    name: 'Pending Reservation',
    initials: 'PR',
    color: Color.YELLOW,
  },
  {
    code: DealStatus.RESERVED,
    name: 'Reserved',
    initials: 'R',
    color: Color.GREY,
  },
];

export const SWEEP_OPTIONS_CODES = {
  [SweepOptions.SWEEP_TARGET_EXACT_SOT]: 1,
  [SweepOptions.SWEEP_TO_FILL]: 3,
  [SweepOptions.SWEEP_TO_HOUR]: 8,
  [SweepOptions.SWEEP_TO_DAYPART]: 7,
  [SweepOptions.SWEEP_TO_DAY]: 6,
  [SweepOptions.SWEEP_WEIGHTED_DISTRIBUTION]: 2,
  [SweepOptions.SWEEP_FLOOR_TO_CEILING_RANGE]: 9,
};

export const SWEEP_OPTIONS_NAMES: { [key in keyof Omit<SweepOptions, SweepOptions.NONE> as string]: string } = {
  [SweepOptions.SWEEP_TARGET_EXACT_SOT]: 'Target exact SOT',
  [SweepOptions.SWEEP_TO_FILL]: 'Sweep to fill',
  [SweepOptions.SWEEP_TO_HOUR]: 'Hour sweep',
  [SweepOptions.SWEEP_TO_DAY]: 'Day sweep',
  [SweepOptions.SWEEP_TO_DAYPART]: 'All day part sweep',
  [SweepOptions.SWEEP_WEIGHTED_DISTRIBUTION]: 'Weighted sweep',
  [SweepOptions.SWEEP_FLOOR_TO_CEILING_RANGE]: 'Add floor to ceiling SOT range',
};

export const SWEEP_OPTIONS_INFO = {
  [SweepOptions.NONE]: '',
  [SweepOptions.SWEEP_TARGET_EXACT_SOT]: 'No sweep has been applied. The frame count will not be affected.',
  [SweepOptions.SWEEP_TO_FILL]: 'Sweep to fill any available SOT up to the exact Share of Time targeted in each hour.',
  [SweepOptions.SWEEP_TO_HOUR]: 'Sweep to the exact Share of Time targeted in each hour.',
  [SweepOptions.SWEEP_TO_DAYPART]:
    'All day part sweep has been applied. Frames with the selected share of time per day part that is available have been added to your frame availability.',
  [SweepOptions.SWEEP_TO_DAY]: 'Sweep to the exact Share of Time targeted in each day.',
  [SweepOptions.SWEEP_WEIGHTED_DISTRIBUTION]:
    'Allow the allocation engine to select any frame/hour combinations to optimise deal line allocation.',
  [SweepOptions.SWEEP_FLOOR_TO_CEILING_RANGE]:
    'Add a minimum and maximum range to target frames with SOT between these values.',
};

/* eslint-enable import/no-cycle */
